import io from "socket.io-client";
import Push from "push.js";

var socket;

export default (store) => {
  if (store.state.token) {
    openWebsocket(store, store.state.token);
  }
  store.subscribe((mutation) => {
    if (mutation.type === "LOGIN") {
      openWebsocket(store, mutation.payload.token);
    }
    if (mutation.type === "LOGOUT") {
      closeWebsocket();
    }
  });
};

function openWebsocket(store, token) {
  if (socket) return;
  socket = io(process.env.VUE_APP_NIREX_API_URL, {
    reconnectionDelay: 2000,
    reconnectionDelayMax: 60000,
  });
  socket.on("connect", () => {
    socket.emit("authenticate", { token });
    socket.on("authenticated", () => {
      socket.on("welcome", (data) => {
        console.log(data);
      });
    });
    socket.on("unauthorized", () => {
      closeWebsocket();
    });
    socket.on("disconnect", () => {
      closeWebsocket();
    });
    socket.on("order_taken", (data) => {
      if (store.state.id_order) {
        store.dispatch("getTracking", store.state.id_order);
      }
      if (data === "canceled") {
        Push.create("Nirex", {
          body: "!Tu pedido ha sido cancelado!",
          icon: "/favicon-blue.png",
          timeout: 10000,
          onClick: function () {
            window.focus();
            this.close();
          },
        });
        store.dispatch("getOrders");
      }
      if (data === "asignado") {
        Push.create("Nirex", {
          body: "!Tu pedido ha sido asignado!",
          icon: "/favicon-blue.png",
          timeout: 10000,
          onClick: function () {
            window.focus();
            this.close();
          },
        });
        store.dispatch("getOrders");
      } else if (data === "finalizado") {
        Push.create("Nirex", {
          body: "!Tu pedido ha sido entregado!",
          icon: "/favicon-blue.png",
          timeout: 10000,
          onClick: function () {
            window.focus();
            this.close();
          },
        });
        store.dispatch("getOrders");
      }
    });
    socket.on("order point", () => {
      store.dispatch("getOrders");
      if (store.state.id_order) {
        store.dispatch("getTracking", store.state.id_order);
      }
    });

    socket.on("order tracking", (tracking) => {
      store.commit("SET_ORDER_TRACKING", tracking);
      if (store.state.id_order) {
        store.dispatch("getTracking", store.state.id_order);
      }
    });
  });
}

function closeWebsocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
